export const APIMapping = {
  TRIPS_COUNTS: '/trips/summary',
  TRIPS_SEGMENTS: '/events/{eventId}/trip-segments',
  EVENTS: '/events',
  DISTRIBUTION_BY_ZONE: '/events/distribution-by-zone',
  EVENTS_OVER_TIME: '/events/multi-granularity-time-series',
  EVENT_SUMMARY: '/dashboard-summary',
  EVENTS_DETAILS: '/events/{eventId}',
  REPORTS: '/reports',
  REPORTS_EXPORT: '/reports/export',
  SPEED_RFSTRENGTH: '/speed-and-rfstrength-over-time',
  TRIP_SUMMARY_STATISTICS: '/trips/loco-health/summary',
  HEALTH_TIMELINE: '/trips/health-timeline',
  EVENTS_HEALTH_DISTRIBUTION: '/loco-health-events/distribution',
  RADIO_RF_ISSUES_OVER_TIME: '/loco-station/rf-issues',
  SPEEDOMETER_DMI_HEALTH_OVER_TIME: '/loco-speedometer-dmi-health',
  STATION_HEALTH_CARD_STATUS: '/station-health/card-status',
  STATION_HEALTH_S2S_EIGW_SYSTEM_FAILURE: '/station-health/failure-breakdown',
  STATION_HEALTH_SIGNAL_ASPECT_BLANKING: '/station-health/signal-blanking',

  UPDATE_USER: '/update-user/{user_id}',
  RESET_PASSWORD: '/reset-user-password',
  EVIDENCE_TIMELINE: '/events-timeline',
  GET_FILTERS_FOR_EVENTS: '/parameter/by-date',
  TRIP_RF_STRENGTH_SPEED: '/trip-speed-or-rf-strength-over-time',
  LOCO_READER_EFFICIENCY: '/loco-health/reader-efficiency',

  //STATION EVENTS
  KPI_COUNT: '/station-kpi-counts',
  STATION_EVENTS: '/station-events',
  FETCH_DIVISION: '/divisions',

  STATION_EVENTS_RCA: '/station-events/{eventId}',

  GET_EVENT_SUB_CATEGORIES: '/events/subcategories',

  GET_LOCO_HEALTH_NEW: '/loco_health_failure',

  GET_STATION_HEALTH_NEW: '/station_health_failure',

  SPEED_VS_TIME: '/speed-and-spd-over-time',

  DOWLOAD_LOCO_RCA_REPORT: '/reports/incident/download',

  GET_SECTIONS: '/sections',

  GET_UNIFIED_KPI: '/unified-kpi/summary',

  GET_UNIFIED_KPI_SUMMARY: '/unified-kpi/details',

  GET_UNIFIED_KPI_LINE_CHART_DATA: '/unified-kpi/trend',

  GET_LOCOS_IN_LOCO_HEALTH: '/loco_health_failure/loco_ids',

  GET_ZONES_PROJECT_STATION_IN_STATION_HEALTH: '/station_health_failure/filters',

  GET_LOCO_RF_ISSUES_RADIO_HEALTH: '/loco_radio_rf_issues',

  GET_STATION_RF_ISSUES_RADIO_HEALTH: '/station_radio_rf_issues',

  GET_LOCOS_IN_RADIO_HEALTH: '/loco_radio_rf_issues/loco_ids',

  GET_ZONES_PROJECT_STATION_IN_RADIO_HEALTH: '/station_radio_rf_issues/filters',

}